<script>
import {mapState, mapActions} from "vuex";
import bodyLock from "../../mixins/bodyLock";
export default {
  name: "CartToggle",
  mixins: [bodyLock],
  props: {},
  data: () => {
    return {
      pageTitles: [],
    };
  },

  mounted() {},

  computed: {
    ...mapState("cart", {
      cartVisible: "visible",
    }),
    ...mapState("menu", {
      menuVisible: "visible",
    }),
  },

  methods: {
    ...mapActions("cart", {
      cartToggle: "toggle",
      cartShow: "show",
      cartHide: "hide",
    }),

    ...mapActions("menu", {
      menuHide: "hide",
    }),

    toggleCartDisplay() {
      if (this.cartVisible) {
        this.cartHide();
      } else {
        this.menuHide();
        this.cartShow();
      }
    },
  },

  render() {
    return this.$slots.default({
      cartToggle: this.toggleCartDisplay,
      cartVisible: this.cartVisible,
      menuVisible: this.menuVisible,
      menuHide: this.menuHide,
    });
  },
};
</script>
